import styles from './index.module.scss';

const SEARCH_TABS = [
  { id: 'generators', label: 'Generators' },
  { id: 'people', label: 'People' },
];

export default function SearchTabs({ activeTab, onTabChange, isScrolled }) {
  return (
    <div className={styles.searchTabs}>
      {SEARCH_TABS.map((tab) => (
        <button
          key={tab.id}
          className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''} ${
            !isScrolled && activeTab !== tab.id ? styles.showBorder : ''
          }`}
          onClick={() => onTabChange(tab.id)}
          type="button"
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
